import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  Button,
  Box,
} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

const TermsAndConditionsModal = ({isOpen, onClose}) => {
  const {t} = useTranslation('points')

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent maxH="80vh">
        <ModalHeader>
          {t('points:connectionDrawer.termsModal.virgin.title')}
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <Box>
            <Text textStyle="body-small" color="gray.700" mb={4}>
              <strong>1. Conversion Rate</strong>
            </Text>

            <Text textStyle="body-small" color="gray.600" mb={4}>
              You may convert two (2) M-Coin to one (1) Velocity Point. The
              minimum conversion per transaction is 1,000 Velocity Points, which
              requires 2,000 M-Coins. Velocity Points cannot be allocated in
              fractions.
            </Text>

            <Text textStyle="body-small" color="gray.700" mb={4}>
              <strong>2. Account Connection</strong>
            </Text>
            <Text textStyle="body-small" color="gray.600" mb={4}>
              Velocity Points will only be credited to the Virgin Australia
              Business Flyer account linked to your Marmalade account. This
              connection is established upon your first conversion request with
              Virgin Australia Business Flyer.
            </Text>

            <Text textStyle="body-small" color="gray.700" mb={4}>
              <strong>3. Processing Time</strong>
            </Text>

            <Text textStyle="body-small" color="gray.600" mb={4}>
              Marmalade will use reasonable endeavours to allocate Velocity
              Points to your linked account within *seven (7) business days* of
              receiving a valid transfer request.
            </Text>

            <Text textStyle="body-small" color="gray.700" mb={4}>
              <strong>4. Eligibility</strong>
            </Text>

            <Text textStyle="body-small" color="gray.600" mb={4}>
              To convert Velocity Points, you must be an active Virgin Australia
              BusinessFlyer member. Participation, membership, and the earning
              and conversion of Velocity Points are subject to the{' '}
              <a href="https://www.virginaustralia.com/au/en/fly-for-business/business-flyer/terms-conditions/">
                Virgin Australia Business Flyer
              </a>{' '}
              and{' '}
              <a href="https://www.velocityfrequentflyer.com/member-support/terms-conditions">
                Velocity membership Terms and Conditions
              </a>{' '}
              (as amended from time to time). Any changes to Velocity Points
              earning or conversion, including those relating to Marmalade, will
              be governed by those Terms & Conditions.
            </Text>

            <Text textStyle="body-small" color="gray.700" mb={4}>
              <strong>5. Privacy Policy</strong>
            </Text>
            <Text textStyle="body-small" color="gray.600" mb={4}>
              Velocity collects and handles your personal information in
              accordance with its{' '}
              <a href="https://www.virginaustralia.com/au/en/about-us/policies/privacy/">
                Privacy Policy
              </a>
              , and Virgin Australia Business Flyer collects and handles your
              personal information in accordance with its{' '}
              <a href="https://www.virginaustralia.com/au/en/about-us/policies/privacy/privacy-statement-business-flyer/">
                Privacy Policy
              </a>
              .
            </Text>

            <Text textStyle="body-small" color="gray.700" mb={4}>
              <strong>6. Data Sharing</strong>
            </Text>

            <Text textStyle="body-small" color="gray.600" mb={4}>
              By linking your Virgin Australia Business Flyer membership to your
              Marmalade account, you authorise Marmalade to share relevant
              personal information with Virgin Australia Business Flyer. This
              information may be used for purposes related to your linked
              accounts, including (a) confirming your membership status, and (b)
              linking and administering the accounts.
            </Text>

            <Text textStyle="body-small" color="gray.700" mb={4}>
              <strong>7. Responsibility for Use</strong>
            </Text>
            <Text textStyle="body-small" color="gray.600" mb={4}>
              Marmalade is not responsible for the use, conversion, or
              management of Velocity Points once credited to your Velocity
              account. All queries regarding the use of Velocity Points should
              be directed to Virgin Australia Business Flyer.
            </Text>
          </Box>
        </ModalBody>

        <ModalFooter>
          <Button variant="primary" onClick={onClose}>
            {t('points:connectionDrawer.termsModal.closeButton')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

TermsAndConditionsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default TermsAndConditionsModal
